import { useQuery } from "@tanstack/react-query"
import { Moment } from "config"
import { API } from "config"

const useBlackBNF = (list = '200', term = null, period) => useQuery({ queryKey: ['black-bnf', term, list, period], queryFn: async () => {
    const callback = await API.get(`/tools/black-bnf?list=${list}${term ? `&term=${term}` : ''}&start_at=${Moment(period[0]).unix()}&end_at=${Moment(period[1]).unix()}`)
    return callback?.data
}})

export default useBlackBNF